import { z } from 'zod';
import { SignalsApplicationIdParamsSchema } from './signals.schema';

export const SignalSourceFilterOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});
export type SignalSourceFilterOption = z.infer<
  typeof SignalSourceFilterOptionSchema
>;

export const SignalSourceFilterOptionsSchema = z.object({
  sourceLabels: z.array(SignalSourceFilterOptionSchema),
  importBatchIds: z.array(SignalSourceFilterOptionSchema),
  hasThirdPartySignals: z.boolean(),
});
export type SignalSourceFilterOptions = z.infer<
  typeof SignalSourceFilterOptionsSchema
>;

export const GetSignalSourceFilterOptionsParamsSchema =
  SignalsApplicationIdParamsSchema;
